(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-');
  }

  function getStrongLeadText(p) {
    var strong = p.querySelector('strong');
    return strong ? strong.textContent.trim() : '';
  }

  function stripLeadingStrong(p) {
    var strong = p.querySelector('strong');
    if (strong) strong.remove();
    if (p.firstChild && p.firstChild.nodeType === 3) {
      p.firstChild.textContent = p.firstChild.textContent.replace(/^[\s:]+/, ' ');
    }
  }

  function moveVideoToHeroSlot(content) {
    var slot = document.getElementById('ig-video-slot');
    if (!slot) return;
    var iframe = content.querySelector('iframe');
    if (!iframe) return;
    var wrapper = document.createElement('div');
    wrapper.className = 'video-embed';
    wrapper.appendChild(iframe);
    slot.appendChild(wrapper);
  }

  function cleanEmptyParagraphs(content) {
    content.querySelectorAll('p').forEach(function (p) {
      if (p.children.length === 0 && p.textContent.trim() === '') p.remove();
    });
  }

  function fillSpecStrip(content) {
    var specs = { model: '', product: '', time: '' };
    var paras = Array.prototype.slice.call(content.querySelectorAll('p'));

    paras.forEach(function (p) {
      var lead = getStrongLeadText(p).replace(/:$/, '').toLowerCase();
      if (lead === 'model' || lead === 'product' || lead === 'time') {
        var clone = p.cloneNode(true);
        var strong = clone.querySelector('strong');
        if (strong) strong.remove();
        specs[lead] = clone.textContent.trim();
        p.classList.add('ig-quickfact-hidden');
      }
    });

    var stepCount = Array.prototype.filter.call(content.querySelectorAll('h2'), function (h) {
      return /^Step\s+\d+/i.test(h.textContent.trim());
    }).length;

    var setSpec = function (key, value) {
      var el = document.querySelector('[data-spec="' + key + '"]');
      if (el && value) el.textContent = value;
    };

    setSpec('model', specs.model);
    setSpec('product', specs.product);
    setSpec('time', specs.time);
    setSpec('steps', stepCount ? String(stepCount) : '');
  }

  function styleDisclaimer(content) {
    var blockquotes = content.querySelectorAll('blockquote');
    blockquotes.forEach(function (bq) {
      var text = bq.textContent.trim();
      if (!/please note|reference only|assumes no liability|qualified motorcycle mechanic/i.test(text)) return;
      if (bq.closest('.ig-step')) return;
      bq.classList.add('ig-callout--note');
      var p = bq.querySelector('p') || bq;
      var label = getStrongLeadText(p) || 'Please Note';
      stripLeadingStrong(p);
      var labelEl = document.createElement('span');
      labelEl.className = 'ig-callout-label';
      labelEl.textContent = label.replace(/:$/, '');
      p.parentNode.insertBefore(labelEl, p);
    });
  }

  function findHeading(content, pattern) {
    var headings = content.querySelectorAll('h2');
    for (var i = 0; i < headings.length; i++) {
      if (pattern.test(headings[i].textContent.trim())) return headings[i];
    }
    return null;
  }

  function styleToolsList(content) {
    var heading = findHeading(content, /Tools You'?ll Need/i);
    if (!heading) return;
    var ul = heading.nextElementSibling;
    if (ul && ul.tagName === 'UL') ul.classList.add('ig-tools-list');
  }

  function moveFitmentAboveTools(content) {
    var fitment = document.getElementById('ig-fitment');
    if (!fitment) return;
    var toolsHeading = findHeading(content, /Tools You'?ll Need/i);
    if (toolsHeading) {
      toolsHeading.parentNode.insertBefore(fitment, toolsHeading);
    }
  }

  function styleTorqueSpecs(content) {
    var heading = findHeading(content, /Torque Specs/i);
    if (!heading) return;
    var table = heading.nextElementSibling;
    if (!table || table.tagName !== 'TABLE') return;

    table.classList.add('ig-torque-table');

    var wrap = document.createElement('div');
    wrap.className = 'ig-torque-wrap';

    heading.classList.add('ig-torque-title');

    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(heading);
    wrap.appendChild(table);
  }

  function styleGoodToKnow(content) {
    var heading = findHeading(content, /Good to Know/i);
    if (!heading) return;
    var ul = heading.nextElementSibling;
    if (!ul || ul.tagName !== 'UL') return;

    var wrap = document.createElement('div');
    wrap.className = 'ig-good-to-know';

    heading.classList.add('ig-gtk-title');

    ul.parentNode.insertBefore(wrap, ul);
    wrap.appendChild(heading);
    wrap.appendChild(ul);
  }

  function styleStepCallout(bq) {
    bq.classList.add('ig-callout--step');
    var p = bq.querySelector('p') || bq;
    var label = getStrongLeadText(p);
    if (label) {
      stripLeadingStrong(p);
      var labelEl = document.createElement('span');
      labelEl.className = 'ig-callout-label';
      labelEl.textContent = label.replace(/:$/, '');
      p.parentNode.insertBefore(labelEl, p);
    }
  }

  function buildSteps(content) {
    var allHeadings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    var stepHeadings = allHeadings.filter(function (h) {
      return /^Step\s+\d+/i.test(h.textContent.trim());
    });

    var railItems = [];

    stepHeadings.forEach(function (heading) {
      var rawText = heading.textContent.trim();
      var numMatch = rawText.match(/^Step\s+(\d+)/i);
      var num = numMatch ? numMatch[1] : '';

      var timeLink = heading.querySelector('a');
      var timeHref = timeLink ? timeLink.getAttribute('href') : '';
      var timeText = timeLink ? timeLink.textContent.trim() : '';

      var titleText = rawText
        .replace(/^Step\s+\d+:\s*/i, '')
        .replace(/\(\s*\d{1,2}:\d{2}(:\d{2})?\s*\)\s*$/, '')
        .trim();

      var slug = slugify('step-' + num + '-' + titleText);
      heading.id = slug;

      var body = [];
      var node = heading.nextElementSibling;
      while (node && node.tagName !== 'H2') {
        var next = node.nextElementSibling;
        body.push(node);
        node = next;
      }

      var stepEl = document.createElement('div');
      stepEl.className = 'ig-step';
      stepEl.id = slug;

      var headEl = document.createElement('div');
      headEl.className = 'ig-step__head';
      headEl.innerHTML =
        '<span class="ig-step__num">' + (num.length < 2 ? '0' + num : num) + '</span>' +
        '<h2 class="ig-step__title"></h2>';
      headEl.querySelector('.ig-step__title').textContent = titleText;

      var timeEl = null;
      if (timeHref) {
        timeEl = document.createElement('a');
        timeEl.className = 'ig-step__time';
        timeEl.href = timeHref;
        timeEl.textContent = '▶ ' + timeText;
      }

      var bodyWrap = document.createElement('div');
      bodyWrap.className = 'ig-step__body';
      body.forEach(function (el) {
        if (el.tagName === 'BLOCKQUOTE') styleStepCallout(el);
        bodyWrap.appendChild(el);
      });

      stepEl.appendChild(headEl);
      if (timeEl) stepEl.appendChild(timeEl);
      stepEl.appendChild(bodyWrap);

      heading.parentNode.insertBefore(stepEl, heading);
      heading.remove();

      railItems.push({ id: slug, num: num, title: titleText, time: timeText });
    });

    return railItems;
  }

  function buildRail(railItems, handle) {
    var listEl = document.getElementById('ig-rail-list');
    var countEl = document.getElementById('ig-rail-count');
    var barFillEl = document.getElementById('ig-rail-bar-fill');
    if (!listEl || !railItems.length) {
      var rail = document.getElementById('ig-rail');
      if (rail && !railItems.length) rail.style.display = 'none';
      return;
    }

    var storageKey = 'ig-progress-' + (handle || 'guide');
    var done = {};
    try {
      done = JSON.parse(window.localStorage.getItem(storageKey) || '{}');
    } catch (e) {
      done = {};
    }

    function save() {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(done));
      } catch (e) {}
    }

    function updateProgress() {
      var doneCount = railItems.filter(function (item) {
        return done[item.id];
      }).length;
      countEl.textContent = doneCount + ' / ' + railItems.length;
      barFillEl.style.width = Math.round((doneCount / railItems.length) * 100) + '%';
    }

    railItems.forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ig-rail__item' + (done[item.id] ? ' is-done' : '');
      btn.setAttribute('data-step-id', item.id);

      var dot = document.createElement('span');
      dot.className = 'ig-rail__dot';
      dot.textContent = done[item.id] ? '✓' : item.num;

      var bodyEl = document.createElement('span');
      bodyEl.className = 'ig-rail__item-body';

      var titleEl = document.createElement('span');
      titleEl.className = 'ig-rail__item-title';
      titleEl.style.display = 'block';
      titleEl.textContent = item.title;

      var timeEl = document.createElement('span');
      timeEl.className = 'ig-rail__item-time';
      timeEl.style.display = 'block';
      timeEl.textContent = item.time ? '▶ ' + item.time : '';

      bodyEl.appendChild(titleEl);
      bodyEl.appendChild(timeEl);
      btn.appendChild(dot);
      btn.appendChild(bodyEl);

      btn.addEventListener('click', function () {
        done[item.id] = !done[item.id];
        btn.classList.toggle('is-done', !!done[item.id]);
        dot.textContent = done[item.id] ? '✓' : item.num;
        save();
        updateProgress();
      });

      listEl.appendChild(btn);
    });

    updateProgress();
  }

  function parseTotalTime(text) {
    if (!text) return null;
    var hrMin = text.match(/(\d+)\s*h(?:r|our)?s?\D+(\d+)\s*m/i);
    if (hrMin) return 'PT' + hrMin[1] + 'H' + hrMin[2] + 'M';
    var min = text.match(/(\d+)\s*min/i);
    if (min) return 'PT' + min[1] + 'M';
    return null;
  }

  function getVideoThumbnail() {
    var iframe = document.querySelector('#ig-video-slot iframe');
    if (!iframe) return null;
    var src = iframe.getAttribute('src') || '';
    var match = src.match(/embed\/([\w-]+)/);
    if (!match) return null;
    return 'https://img.youtube.com/vi/' + match[1] + '/hqdefault.jpg';
  }

  function injectHowToSchema(railItems) {
    if (!railItems.length) return;

    var titleEl = document.querySelector('.ig-title');
    var subtitleEl = document.querySelector('.ig-subtitle');
    var timeEl = document.querySelector('[data-spec="time"]');

    var steps = railItems.map(function (item, i) {
      var stepEl = document.getElementById(item.id);
      var bodyEl = stepEl ? stepEl.querySelector('.ig-step__body') : null;
      var text = bodyEl ? bodyEl.textContent.replace(/\s+/g, ' ').trim() : item.title;
      var step = {
        '@type': 'HowToStep',
        position: i + 1,
        name: item.title,
        text: text,
        url: window.location.href.split('#')[0] + '#' + item.id,
      };
      return step;
    });

    var tools = Array.prototype.map.call(
      document.querySelectorAll('.ig-tools-list li'),
      function (li) {
        return li.textContent.trim();
      }
    );

    var schema = {
      '@context': 'https://schema.org',
      '@type': 'HowTo',
      name: titleEl ? titleEl.textContent.trim() : document.title,
      description: subtitleEl ? subtitleEl.textContent.trim() : '',
      step: steps,
    };

    var thumbnail = getVideoThumbnail();
    if (thumbnail) schema.image = thumbnail;

    if (tools.length) {
      schema.tool = tools.map(function (t) {
        return { '@type': 'HowToTool', name: t };
      });
    }

    var totalTime = parseTotalTime(timeEl ? timeEl.textContent : '');
    if (totalTime) schema.totalTime = totalTime;

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }

  function init() {
    var content = document.querySelector('.install-guide-content');
    if (!content) return;
    var handle = document.getElementById('ig-guide')
      ? document.getElementById('ig-guide').getAttribute('data-article-handle')
      : 'guide';

    moveVideoToHeroSlot(content);
    fillSpecStrip(content);
    styleDisclaimer(content);
    styleToolsList(content);
    moveFitmentAboveTools(content);
    styleTorqueSpecs(content);
    styleGoodToKnow(content);
    var railItems = buildSteps(content);
    buildRail(railItems, handle);
    cleanEmptyParagraphs(content);
    injectHowToSchema(railItems);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
